import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { addWeeks } from "date-fns";
import { computed } from "vue";
import OrderSumBNPL from "./OrderSumBNPL.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderSumBNPLDolyame',
    props: {
        sum: { type: Number, required: true },
    },
    setup(__props) {
        const props = __props;
        const payments = computed(() => {
            let payments = [];
            for (let number = 1; number <= 4; number++) {
                payments.push({
                    amount: makeAmount(number),
                    date: addWeeks(new Date(), (number - 1) * 2),
                });
            }
            return payments;
        });
        function makeAmount(number) {
            const partSum = Math.floor(props.sum / 4);
            return number === 4 ? props.sum - partSum * 3 : partSum;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(OrderSumBNPL, { payments: payments.value }, null, 8 /* PROPS */, ["payments"]));
        };
    }
});
